<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 OS-m — Solicitações de prazo
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Esta parte explica como
        strong  listar
        | ,
        strong  visualizar
        | ,
        strong  autorizar
        |  ou
        strong  recusar
        |  pedidos de alteração de prazo feitos pelos fiscais, no menu
        strong  OS-m → Solicitações de Prazo
        | .

      .toast.toast-primary
        | A listagem exige a permissão
        strong  Ordem serviço - Solicitações de prazo → Listar
        | .

      h5.h5 1. Abrir Solicitações de Prazo
      ol
        li No menu lateral, clique em
          strong  OS-m
          | .
        li Clique em
          strong  Solicitações de Prazo
          | .

      h5.h5 2. Filtros e listagem
      figure.manual-figure
        img(:src="imgLista" alt="Listagem de Solicitações de Prazo com filtros")
      p Filtros disponíveis:
      ul
        li
          strong Usuário solicitou
          |  — fiscal que pediu o prazo
        li
          strong Grupo
          |  — grupo do usuário
        li
          strong Situação
          |  — Solicitado, Autorizado ou Recusado (o padrão ao abrir é
          strong  Solicitado
          | )
      ol
        li Ajuste os filtros e clique no ícone de
          strong  funil
          |  para aplicar.
        li A tabela mostra: OS, datas da OS, quem solicitou, data pedida,
          |  situação e o ícone
          strong  Exibir
          |  (olho).

      h5.h5 3. Visualizar a solicitação
      ol
        li Na linha desejada, clique no ícone
          strong  Exibir
          | .
        li Abre o modal
          strong  Solicitação de Prazo
          |  com OS, solicitante, data pedida, situação e motivo.
      figure.manual-figure
        img(:src="imgModal" alt="Modal Solicitação de Prazo")
      p
        | Se a situação for
        strong  Solicitado
        | , o modal mostra as opções
        strong  Autorizar
        |  e
        strong  Recusar
        | . Solicitações já tratadas exibem dados de autorização ou motivo da
        |  recusa, sem novos botões de ação.

      h5.h5 4. Autorizar
      figure.manual-figure
        img(:src="imgAutorizar" alt="Modal com opção Autorizar selecionada")
      ol
        li Com a situação
          strong  Solicitado
          | , selecione
          strong  Autorizar
          | .
        li Informe
          strong  Autorizado concluir em
          |  (obrigatório; o sistema sugere a data pedida).
        li Clique em
          strong  Autorizar
          |  no rodapé do modal.

      h5.h5 5. Recusar
      figure.manual-figure
        img(:src="imgRecusar" alt="Modal com opção Recusar selecionada")
      ol
        li Selecione
          strong  Recusar
          | .
        li Informe o
          strong  Motivo recusado
          |  (obrigatório).
        li Clique em
          strong  Recusar
          |  no rodapé do modal.
      p Para sair sem gravar, feche o modal com
        strong  ×
        | .

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgLista: require("@/assets/manuais/08-osm-solicitacoes-lista.png"),
      imgModal: require("@/assets/manuais/08a-osm-solicitacao-modal.png"),
      imgAutorizar: require("@/assets/manuais/08b-osm-solicitacao-autorizar.png"),
      imgRecusar: require("@/assets/manuais/08c-osm-solicitacao-recusar.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
